import { useMemo } from 'react';
import { useGeoLocation } from 'hooks/useGeoLocation';
import type { LatLng } from './geo';

/**
 * The viewer's own point, for the "{n}mi" labels only — where a search looks is
 * DEFAULT_SEARCH_CENTER or the picked neighborhoods, never this. Null until their
 * location resolves, which hides the distance rather than inventing one.
 *
 * Memoised: a fresh object each render would invalidate the memos inside
 * useFindGames/useFindPlayers, and with them every memo downstream.
 */
export const useViewerCenter = (): LatLng | null => {
  const { position } = useGeoLocation();
  const latitude = position?.latitude;
  const longitude = position?.longitude;

  return useMemo(
    () => (latitude != null && longitude != null ? { lat: latitude, lng: longitude } : null),
    [latitude, longitude],
  );
};
